/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Familiar_TitleInputs */

const en_wc_why_familiar_title = /** @type {(inputs: Wc_Why_Familiar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familiar from minute one`)
};

/**
* | output |
* | --- |
* | "Familiar from minute one" |
*
* @param {Wc_Why_Familiar_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_familiar_title = /** @type {((inputs?: Wc_Why_Familiar_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Familiar_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_familiar_title(inputs)
});
export { wc_why_familiar_title as "wc.why.familiar.title" }